import { GET_SLOTS_DATA, GET_BOARDING_PATTERN_DATA, GET_GUEST_COUNT } from './../constants/actionTypes'
import get from 'lodash/get'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import orderBy from 'lodash/orderBy'

const slots = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_SLOTS_DATA: {
      const slots = get(action.data, 'data', [])
      let latestBoardingSlot = ''
      let activeCount = 0
      const sortedData = orderBy(slots, ['boardingSlotStartTime'], ['asc'])
      sortedData.forEach((slot, index) => {
        if (!slot.slotNumber) {
          sortedData.splice(index, 1)
          sortedData.unshift(slot)
        }
      })
      sortedData.forEach((item) => {
        if (item.isActive) {
          activeCount++
        }
      })
      const latestBoardingGroup = find(sortedData, { 'isActive': true })
      if (!isEmpty(latestBoardingGroup)) {
        latestBoardingSlot = latestBoardingGroup
      }
      return {
        data: sortedData,
        latestBoardingSlot,
        activeCount
      }
    }
    default:
      return store
  }
}



const boardingPattern = (store = {}, action = {}) => {
  if(action.type === GET_BOARDING_PATTERN_DATA){
    return action.data
  }
  else{
    return store
  }
}

const guestCount = (store = {}, action = {}) => {
  if(action.type === GET_GUEST_COUNT){
    return action.data
  }
  else{
    return store
  }
} 

export {slots,boardingPattern,guestCount} 
